export const LOCAL_STORAGE_KEYS = {
  GRADE: 'ckla_hub_grade',
  BOOK_PAGE_SAVES: 'book_page_saves',
}

export const LOCAL_STORAGE_EVENTS = {
  GRADE_CHANGE: 'GRADE_CHANGE',
}
